import { Component, Inject, OnInit } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { ClienteService } from 'src/app/services/cliente.service';
import { ConfirmacionService } from 'src/app/services/confirmacion.service';
import { GrupoService } from 'src/app/services/grupo.service';
import { LoginService } from 'src/app/services/login.service';
import {MatDialogRef, MAT_DIALOG_DATA} from "@angular/material/dialog"
import { ZonasGruposComponent } from '../../zonas-grupos.component';

@Component({
  selector: 'app-nuevo-grupo',
  templateUrl: './nuevo-grupo.component.html',
  styleUrls: ['./nuevo-grupo.component.scss']
})
export class NuevoGrupoComponent implements OnInit {

  public userLogged: any

  public grupos: any;
  public campos : any[] = [];
  public grupoSeleccionado: any;
  public camposSeleccionado: any[] = [];
  public inputNewCampo: any;
  public inputNameCampo: any ;
  public instalaciones: any;
  public instalacionSeleccionada: any[] = [];

  constructor(
    private loginService: LoginService,
    private grupoService: GrupoService, 
    private apollo: Apollo,
    private confirmacionService: ConfirmacionService,
    private clienteService: ClienteService, public dialogRef: MatDialogRef<ZonasGruposComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.userLogged = loginService.getUserData()
      if (this.data.grupo.nombre) {
        this.inputNameCampo = this.data.grupo.nombre
      }else{
        this.inputNameCampo = 'Nuevo Grupo'
      }
      
     }

  ngOnInit(): void {
    this.getGruposByCliente();
    this.getGrupoSeleccionado();
    this.getInstalacionesByCliente();
  }
  
  getGruposByCliente() {
    this.apollo.watchQuery<any>({
      query: this.grupoService.getGruposByCliente(),
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.grupos = data.cliente.agrupacions
      
      });
    
  }

  getGrupoSeleccionado(){
  
      this.grupoSeleccionado = this.data.grupo;
      this.getCamposByGrupo()
      
    
  }

  getCamposByGrupo(){
    this.apollo.watchQuery<any>({
      query: this.grupoService.getCamposByGrupo(),
      variables: {
        "id": this.grupoSeleccionado.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.campos = data.agrupacion.campos
      });
  }

  addGrupo(){
    this.apollo.mutate<any>({
      mutation: this.grupoService.addGrupo(),
      variables: {
        "input": {
          "data": {
            "nombre": this.inputNameCampo,
            "cliente": this.userLogged.cliente.id,
          }
        }
      }
    }).subscribe(({data}) => {
      console.log('CREADO', data)
      location.reload()
    }, (error) => {
      console.log('Error al lanzar la query', error);
    })
  }

  handleClick(e:any){
    const options = {
      text: '¿Está seguro que desea eliminar el registro?',
      cancelText: 'Cancelar',
      confirmText: 'Eliminar'
    };
    this.confirmacionService.open(options);
      
    this.confirmacionService.confirmed().subscribe(confirmed => {
      if (confirmed) {
       this.deleteCampo(e);
       location.reload()
      }
      });
  }

  updateNameGrupo(e:any){
    this.apollo.mutate({
      mutation: this.grupoService.updateGrupo(),
      variables: {
        "input": {
          "where": {
            "id": this.grupoSeleccionado.id
          },
          "data": {
            "nombre": e,

          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data, errors)
        location.reload()
      }, (error) => {
        console.log(error)
      })
  }

  deleteCampo(e: any) {
    this.apollo.mutate({
      mutation: this.grupoService.deleteCampo(),
      variables: {
        "input": {
          "where": {
            "id": e.id
          },
        }
      }
    }).subscribe(({data}) => {
      console.log('BORRADO', data)
    }, (error) => {
      console.log('Error al lanzar la query', error);
    })
  }


  selectAllInstalaciones(e:any){
    if (e) {
      const allInstalaciones = this.instalaciones;
      allInstalaciones.forEach((instalacion:any) => {
        this.instalacionSeleccionada.push(instalacion.id)
      });   
    }else{
      this.instalacionSeleccionada = [];
    }
  }

  selectInstalacion(e:any){

    const instalacion = e.value;
    if (e.selected) {
      this.instalacionSeleccionada?.push(instalacion)
      /* console.log(this.instalacionSeleccionada) */
    }else{
      this.instalacionSeleccionada = this.instalacionSeleccionada?.filter((i:any)=> i !== instalacion) 
      /* console.log(this.instalacionSeleccionada) */
    }
  }

  updateGrupoById(){
    this.apollo.mutate<any>({
      mutation: this.grupoService.addCampo(),
      variables: {
        "input": {
          "data": {
            "nombre": this.inputNewCampo,
            "agrupacion": this.grupoSeleccionado.id,
            "instalacions": this.instalacionSeleccionada
          }
        }
      }
    }).subscribe(({data}) => {
      console.log('CREADO', data)
      location.reload()
    }, (error) => {
      console.log('Error al lanzar la query', error);
    })
  }

  getInstalacionesByCliente() {
    this.apollo.watchQuery<any>({
      query: this.clienteService.getInstalacionesByCliente(),
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.instalaciones = data.cliente.instalaciones

      });
  }

  deleteGrupoById(id:any){
    this.apollo.mutate({
      mutation: this.grupoService.deleteGrupo(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
        }
      }
    })
      .subscribe(({data}) => {
        console.log('BORRADO', {data})
        location.reload()
      }, (error) => {
        console.log(error)
      })
  }

  

  }




